module.exports = __webpack_public_path__ + "static/media/fa-solid-900.9f3c8f80.woff2";